import React from 'react';
import { ReviewStatusType } from '../../../../types/reviewStatus';
import { docReviewStatusStyle } from './reviewStyle';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

type Props = { status: ReviewStatusType };

export default function DocStatusTag({ status }: Props) {
  const statusStyle = docReviewStatusStyle(status);
  const theme = clsx(
    statusStyle,
    status === 'pending' && 'font-semibold border-2',
    'capitalize px-2 py-1 font-medium rounded-2xl block w-fit'
  );
  if (status === 'rejected')
    return (
      <Link to="/dashboard/get-started" className="w-fit block animate-pulse">
        <small className={theme}>Upload valid details</small>
      </Link>
    );
  return <small className={theme}>{status}</small>;
}
